<div *ngFor="let nmfc of nmfcList" class="nmfc-search-link">
  <a (click)="openNmftaSite(nmfc, $event)">{{ nmfc }}</a>
</div>
